import BalanceRuleRenderer from './BalanceRulesRenderer'

class DefaultRulesCell extends BalanceRuleRenderer {
    constructor() {
        super()
        this.defaultMessage = null
    }

    _getRuleValue(ptoData) {
        return this.defaultMessage;
    }

    _customClassName(ptoData) {
        return "defaultRule";
    }

    _handleDefaultPTORules = function(ptoData) {
        return true;
    }
}

export default DefaultRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/DefaultRulesCell.js